export default {"src":"/_next/static/media/card-reporting.f295c074.svg","height":56,"width":51,"blurWidth":0,"blurHeight":0};